import TierLabel from "../UI/TierLabel";
import { useNavigate } from "react-router-dom";
import { timestampToString } from "../../util/timestamp-to-date";

export default function VehicleCard({ vehicle }) {
  const navigate = useNavigate();

  const clickHandler = () => {
    navigate(`/vehicles/info?id=${vehicle.id}`);
  };

  return (
    <div
      onClick={() => clickHandler()}
      className={`${
        vehicle.status.available
          ? vehicle.bookings?.length === 0
            ? "border-green-600"
            : ""
          : "opacity-50"
      } grid items-center gap-4 text-sm md:grid-cols-4 pill grid-cols-2 text-stone-200`}
    >
      <img alt="Vehicle" src={vehicle.images.corner} className="w-24"></img>
      <div className="grid">
        <p className="font-semibold text-stone-200">
          {vehicle.model} {vehicle.year}
        </p>
        <p className="font-semibold text-stone-400">{vehicle.license}</p>
      </div>
      <div className="hidden text-center md:block">
        <p className="text-stone-200">${vehicle.rates.daily}/day</p>
        <p className="text-stone-200">${vehicle.rates.monthly}/month</p>
      </div>

      {vehicle.bookings?.length > 0 ? (
        <div className="hidden text-center md:block">
          <p>
            {timestampToString(
              vehicle.bookings[0].start_date,
              "MMM do - hh:mm a"
            )}
          </p>
          <p>
            {timestampToString(
              vehicle.bookings[0].end_date,
              "MMM do - hh:mm a"
            )}
          </p>
        </div>
      ) : (
        <p className="hidden text-center md:block">not booked</p>
      )}
    </div>
  );
}
